'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _ToolList = require('./ToolList');

var _ToolList2 = _interopRequireDefault(_ToolList);

var _Trash = require('./elementTools/Trash');

var _Trash2 = _interopRequireDefault(_Trash);

require('./Toolbar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolbar = function Toolbar(_ref) {
    var currentBoardId = _ref.currentBoardId,
        isEditable = _ref.isEditable,
        gridSize = _ref.gridSize;

    if (!isEditable) return null;

    return _react2.default.createElement(
        'div',
        { className: 'Toolbar' },
        _react2.default.createElement(_ToolList2.default, { currentBoardId: currentBoardId, gridSize: gridSize }),
        _react2.default.createElement(_Trash2.default, { currentBoardId: currentBoardId })
    );
};

// Styles


// Components


Toolbar.propTypes = {
    isEditable: _propTypes2.default.bool,
    currentBoardId: _propTypes2.default.string.isRequired,
    gridSize: _propTypes2.default.number
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(Toolbar);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/Toolbar.js
// module id = 2218
// module chunks = 0